(ns manatee.components.notifications.container
  (:require [manatee.components.notifications.handlers :as handlers]
            [manatee.components.notifications.subs :as subs]
            [re-frame.core :as rf]
            [rothko.alert.component :as alert]))

(defn announcements "Messages from admin"
  [announcements]
  (into [:div.announcements (when (empty? announcements) {:hidden "yes"})
         [:h4 "Announcements:"]
         [:p]]
        (for [[_ message-text] announcements]
          [:p {:appearance #{:announcement}}
           (str "• " message-text)])))

(defn alerts "Dismissable popups for transient error messages"
  [{:keys [banner-id] :as props}]
  [alert/banner
   (merge {:alerts @(rf/subscribe [::subs/alerts banner-id])
           :on-close (fn [alert-id]
                       (rf/dispatch [::handlers/clear-alert banner-id alert-id]))}
          props)])
